import React, { useState } from "react";
import * as locales from "react-date-range/dist/locale";
import { Calendar } from "react-date-range";

const Datepicker = (props) => {
  const [locale] = React.useState("enUS");
  const [date, setDate] = useState(null);

  const handleDateChange = (DateValue) => {
    setDate(DateValue);
    props.SaveSelectedDate(DateValue);
  };

  return (
    <React.Fragment>
      <div className="outline" onClick={() => props.Close()}></div>
      <div className="date-picker">
        <Calendar
          onChange={(DateValue) => handleDateChange(DateValue)}
          locale={locales[locale]}
          date={date}
        />
      </div>
    </React.Fragment>
  );
};

export default Datepicker;
